<template>
    <div class="video-modal">
      <div class="cover" @click="modalClose()"></div>
      <div class="embed-wrapper">
        <span class="close-wrap">
          <a class="btn" @click="modalClose()">
            <div class="line"></div>
            <div class="line"></div>
          </a>
        </span>
        <youtube :video-id="vidSrc" :width="720" :height="480" :player-vars="option" ref="youtube"
        ></youtube>
      </div>
    </div>
</template>

<script>
export default {
    props:{
        vidSrc: String
    },
    data(){
        return{
            option: {
                autoplay: 1,
            }
        }
    },
    methods:{
        modalClose() {
            this.$emit('clicked');
        }
    }
}
</script>

<style lang="scss">
.video-modal{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  z-index: 100;
  .cover{
    background: rgba($color: #000000, $alpha: .6);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .close-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 50px;
      a.btn{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 34px;
        height: 34px;
          .line{
            position: absolute;
            background: $white;
            width: 100%;
            height: 2px;
            transform: rotate(45deg);
            transform-origin: center;
            @media #{$IE}{
                left: 0;
            }
            &:last-child{
              transform: rotate(-45deg);
            }
          }
      }
  }
.embed-wrapper{
    position: relative;
    height: calc((66vw / 1.77) + 34px);
    overflow: hidden;
    max-width: 100%;
    width: 66%;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    justify-content: center;
    @media screen and (max-width: 960px){
      width: calc(100% - 20px);
      height: calc((100vw - 20px) / 1.77 + 34px);
    }
    iframe{
      width: 100%;
      height: calc((100vw / 1.77) + 34px);
      border: 1px solid #707070;
    }
  }
  @media #{$maxM}{
    
  }
}

</style>